import { storage } from "@/lib/appwrite"
import { ID } from "appwrite"

export const uploadInstrumentImages = async (files: File[]): Promise<string[]> => {
    const uploads = files.map((file) =>
        storage.createFile(
            import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_BUCKET_ID,
            ID.unique(),
            file
        ).then((f) => f.$id)
    )

    return Promise.all(uploads)
}


export const getInstrumentImageUrl = (fileId: string): string => {
    return storage.getFileView(
        import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_BUCKET_ID,
        fileId
    ).toString()
}


export const getInstrumentQrUrl = (fileId: string): string => {
    return storage.getFileView(
        import.meta.env.VITE_BLOCKCHAIN_QRINSTRUMENTS_BUCKET_ID,
        fileId
    ).toString()
}

export const deleteInstrumentImages = async (fileIds: string[]): Promise<void> => {
    await Promise.allSettled(
        fileIds.map(id =>
            storage.deleteFile(import.meta.env.VITE_BLOCKCHAIN_INSTRUMENTS_BUCKET_ID, id)
        )
    )
}